import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { VaFormsModule } from '@vendasta/forms';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { GalaxyWrapModule } from '@vendasta/galaxy/galaxy-wrap';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { VaTableModule } from '@vendasta/uikit';
import en from './assets/en_devel.json';
import { AuxiliaryDataCardComponent } from './auxiliary-data/auxiliary-data-card/auxiliary-data-card.component';
import { AuxiliaryDataPanelComponent } from './auxiliary-data/auxiliary-data-panel/auxiliary-data-panel.component';
import { AuxiliaryDataTableComponent } from './auxiliary-data/auxiliary-data-table/auxiliary-data-table.component';
import { AuxiliaryFieldHandlerService } from './auxiliary-data/auxiliary-field-handler.service';
import { RendererSelectorComponent } from './auxiliary-data/renderer-selector.component';
import {
  CurrencyRendererComponentModule,
  DateRendererComponentModule,
  DropdownRenderComponentModule,
  IntegerRendererComponentModule,
  TextRendererComponentModule,
} from './auxiliary-data/renderers';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    VaFormsModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatSortModule,
    MatDatepickerModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    VaTableModule,
    TranslateModule,
    GalaxyButtonLoadingIndicatorModule,
    LexiconModule.forChild({
      componentName: 'common/auxiliary-data',
      baseTranslation: en,
    }),
    GalaxyPageModule,
    GalaxyEmptyStateModule,
    MatExpansionModule,
    GalaxyWrapModule,
    DropdownRenderComponentModule,
    CurrencyRendererComponentModule,
    DateRendererComponentModule,
    IntegerRendererComponentModule,
    TextRendererComponentModule,
  ],
  declarations: [
    AuxiliaryDataTableComponent,
    RendererSelectorComponent,
    AuxiliaryDataPanelComponent,
    AuxiliaryDataCardComponent,
  ],
  exports: [
    AuxiliaryDataTableComponent,
    AuxiliaryDataPanelComponent,
    AuxiliaryDataCardComponent,
    RendererSelectorComponent,
  ],
  providers: [AuxiliaryFieldHandlerService],
})
export class AuxiliaryDataModule {}
